import { styled } from "@mui/material/styles";
import { Button as ButtonComponent } from "components/button";
import backArrowIcon from "assets/images/icons/arrow-short.svg";
import { PopupActions } from "components/popup/actions";

export const ButtonContainer = styled("div", {
  label: "button-container",
})`
  flex: 3;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing(2)};

  ${({ theme }) => theme.breakpoints.up("md")} {
    margin: ${({ theme }) => theme.spacing(4, 4)};
  }
`;

export const Button = styled(ButtonComponent, {
  label: "button",
})`
  align-items: center;
  font-size: 18px;
  width: auto;
  flex-shrink: 0;

  & + & {
    margin-left: ${({ theme }) => theme.spacing(2.5)};
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    width: auto;
  }
`;

export const Container = styled("div", { label: "price-container" })`
  display: flex;
  align-items: center;
  position: relative;
  padding-left: ${({ theme }) => theme.spacing(4)};

  &:before {
    top: 0;
    content: "";
    position: absolute;
    left: ${({ theme }) => theme.spacing(2)};
    right: ${({ theme }) => theme.spacing(2)};
    height: theme.spacing(0.125);
    background-color: ${({ theme }) => theme.palette.color.gray[85]};
  }
`;

export const Cost = styled("div", { label: "cost" })`
  flex: 3;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: ${({ theme }) => theme.palette.primary.main};
  ${({ theme }) => theme.breakpoints.up("md")} {
    margin: ${({ theme }) => theme.spacing(4, 4)};
  }
  font-size: 54px;
  font-weight: 500;
  line-height: 1.5;
`;

export const ArrowIcon = styled(backArrowIcon, {
  label: "arrow-icon",
})`
  fill: currentColor;
  transform: rotate(-180deg);
  width: ${({ theme }) => theme.spacing(2.5)};
  stroke: currentColor;
`;

export const TripCostActions = styled(PopupActions, {
  label: "trip-cost-actions",
})`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(4)};
  margin: ${({ theme }) => theme.spacing(3.5, "auto")};
`;

export const PriceContainer = styled("div", {
  label: "price-container",
})`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing(0.5)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const PricePerDay = styled("div", {
  label: "price-per-day",
})`
  font-size: 18px;
  color: ${({ theme }) => theme.palette.color.primary.main};
  font-weight: 400;
  line-height: 1.5;
`;
